import { useContext } from "react";

// context
import FormSelectDialogContext from "./index";

// store
import { actionTypes } from "./store";

export const useFormSelectDialog = () => {
    const { state, dispatch, isControlled, parentalControl, ...extraProps } =
        useContext(FormSelectDialogContext);

    // Action Creators
    const setHasOpenedBefore = hasOpenedBefore => {
        dispatch({
            type: actionTypes.SET_HAS_OPENED_BEFORE,
            hasOpenedBefore,
        });
    };
    const setIsOpen = isOpen => {
        parentalControl?.onOpenChange?.(isOpen);
        if (!isControlled) {
            dispatch({
                type: actionTypes.SET_IS_OPEN,
                isOpen,
            });
        }
    };
    const setOpenCloseButtonIsInFocus = openCloseButtonIsInFocus => {
        dispatch({
            type: actionTypes.SET_OPEN_CLOSE_BUTTON_IS_IN_FOCUS,
            openCloseButtonIsInFocus,
        });
    };

    return {
        ...state,
        ...extraProps,
        isOpen: isControlled ? parentalControl.isOpen : state.isOpen,
        isControlled,
        parentalControl,
        setIsOpen,
        setHasOpenedBefore,
        setOpenCloseButtonIsInFocus,
    };
};
